import { Avatar, Tooltip } from '@mui/material';
import React from 'react';
import tinycolor from 'tinycolor2';
import useAppointment from '../../../../../hooks/useAppointment';
import { Appointment, AppointmentStateEnum } from '../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../services/helper';

interface AppointmentSlotProps {
  appointment: Appointment;
  onClick: () => void;
  startTime: number;
  endTime: number;
  slotIndex: number;
  bookingmode: boolean;
  boothId?: string;
}
const AppointmentSlot = ({ appointment, onClick, startTime, endTime, slotIndex, bookingmode, boothId }: AppointmentSlotProps) => {
  const event = useSelector((state) => state.admin.event || state.common.event);

  const { getAppointmentState, getTooltipText, getAppointmentMark } = useAppointment(boothId, !bookingmode);

  function time2dec(time: any) {
    const _date = new Date(Date.parse(time));
    return _date.getHours() + _date.getMinutes() / 60;
  }

  return (
    <>
      <Tooltip
        key={'slots-appointment-' + slotIndex}
        className="appointment-slot"
        title={
          <div className="flex">
            {getAppointmentState(appointment) === AppointmentStateEnum.BOOKED_BY_USER && (
              <div style={{ marginRight: '1em' }}>
                <Avatar src={createDisplayLink(appointment.user.avatar, undefined, undefined, undefined, undefined, undefined, true)} />
              </div>
            )}
            <div className="flex flex-col justify-between h-full">
              <span> {getTooltipText(getAppointmentState(appointment), appointment)}</span>
              <span>{getAppointmentState(appointment) === AppointmentStateEnum.BOOKED_BY_USER && appointment.user.email}</span>
            </div>
          </div>
        }>
        <div
          key={appointment._id}
          onClick={() => {
            if (![AppointmentStateEnum.NOT_AVAILABLE, AppointmentStateEnum.CREATED_BY_SELF].includes(getAppointmentState(appointment))) onClick();
          }}
          className={
            `absolute h-[2em] bg-[#cfcfcf] rounded transition-all flex justify-center items-center text-white cursor-pointer select-none 
            hover:bg-[#8a8a8a] ${
              getAppointmentState(appointment) === AppointmentStateEnum.BOOKED_BY_USER || getAppointmentState(appointment) === AppointmentStateEnum.AVAILABLE
                ? 'booked'
                : getAppointmentState(appointment) === AppointmentStateEnum.CAN_UNBOOK
                ? 'blue'
                : getAppointmentState(appointment) === AppointmentStateEnum.NOT_AVAILABLE || AppointmentStateEnum.CREATED_BY_SELF
                ? 'disabled'
                : ''
            }` + ' templateBorder'
          }
          style={{
            width: `${(100 * (time2dec(appointment.datetime_end) - time2dec(appointment.datetime_start))) / (endTime - startTime + 1)}%`,
            left: `${(100 * (time2dec(appointment.datetime_start) - startTime + 0.5)) / (endTime - startTime + 1)}%`,

            bottom: `${slotIndex * 3 + 2}em`,
          }}>
          {getAppointmentMark(getAppointmentState(appointment))}
        </div>
      </Tooltip>
      <style jsx>{`
        .booked {
          background-color: ${event?.template.mainColor || 'var(--vystem-blue)'};
          color: ${event?.template.mainButtonTextColor || 'white'};

          &:hover {
            background-color: ${event?.template.mainColor ? tinycolor(event?.template.mainColor).darken(20).toString() : 'var(--vystem-blue-dark)'};
          }
        }
      `}</style>
    </>
  );
};

export default AppointmentSlot;
